var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",attrs:{"id":"#app2"}},[_c('DropdownMenuContent'),_c('Navbar'),_c('DashboardTabs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }